var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "nav-box" }, [
    _c("div", { staticClass: "left-item" }, [
      _c(
        "div",
        { class: { "back-show": !_vm.backFlag }, on: { click: _vm.backHome } },
        [
          _c("Icon", {
            staticClass: "back-span",
            attrs: { type: "ios-arrow-back" },
          }),
          _c("span", { staticClass: "back-span back-margin" }, [
            _vm._v(_vm._s(_vm.$t("common.back"))),
          ]),
        ],
        1
      ),
      _c("span", [_vm._v(_vm._s(_vm.routerName))]),
    ]),
    _vm.languageFlag
      ? _c(
          "div",
          { staticClass: "right-item" },
          [
            _c(
              "Dropdown",
              {
                attrs: { trigger: "click" },
                on: { "on-click": _vm.changeLanguage },
              },
              [
                _c(
                  "Button",
                  { attrs: { type: "default", ghost: "" } },
                  [
                    _vm._v(" " + _vm._s(_vm.languageName) + " "),
                    _c("Icon", { attrs: { type: "ios-arrow-down" } }),
                  ],
                  1
                ),
                _c(
                  "DropdownMenu",
                  { attrs: { slot: "list" }, slot: "list" },
                  _vm._l(_vm.LanguageList, function (item) {
                    return _c(
                      "DropdownItem",
                      { key: item.type, attrs: { name: item.type } },
                      [_vm._v(" " + _vm._s(item.name) + " ")]
                    )
                  }),
                  1
                ),
              ],
              1
            ),
          ],
          1
        )
      : _vm._e(),
    _vm.versionFlag
      ? _c(
          "div",
          { staticClass: "right-item" },
          [
            _c("Button", { attrs: { type: "primary" } }, [
              _vm._v(_vm._s(_vm.version)),
            ]),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }